import React, { FC } from "react";
import classNames from "classnames";
import { Card, CardProps } from "../Card/Card";

type InformationCardProps = Omit<CardProps, 'iconName'>;

export const InformationCard: FC<InformationCardProps> = (props) => {
	const { className } = props;

	return (
		<Card {...props} className={classNames("InformationCard", className)} iconName="info" iconSize="medium" />
	);
};
